
<template>
    <div >
        <div style="border: 1px solid #e9e9e9; border-radius: 1rem;">
            <q-card-section>
                <div class="text-bold" style="font-size: 16px;">{{$t("stepper.title6")}}</div>
            </q-card-section>
            <q-separator style="margin: 0 0.75rem; width: auto;"/>
            <q-card-section>
                <div class="row contentLabel">
                    
                        <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                            {{$t("Applicant-Detail.salutation")}}
                        </div>
                        <div class="col-xs-12 col-md-3 q-mb-md">
                            {{StoreStateAOD.PersonalInformation.Salutation}}
                        </div>
                    

                    
                        <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                            {{$t("Applicant-Detail.fullname2")}}
                            <q-btn unelevated outline round size="xs" color="primary" icon="fas fa-info" style="font-size: 5px;">
                                <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]" style="font-size: 12px;">
                                    {{$t("Applicant-Detail.fullname2info")}}
                                </q-tooltip>
                            </q-btn>
                        </div>
                        <div class="col-xs-12 col-md-3 q-mb-md">
                            {{StoreStateAOD.PersonalInformation.FullName}}
                        </div>
                    
                </div>
                <div class="row contentLabel">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.newic")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.PersonalInformation.NRIC}}
                    </div>
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.oldic")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.PersonalInformation.OldID ? StoreStateAOD.PersonalInformation.OldID : '-'}}
                    </div>
                </div>
                 <div class="row contentLabel">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.race")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.PersonalInformation.Race}}
                    </div>
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.dob")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.PersonalInformation.DateOfBirth}}
                    </div>
                </div>

                 <div class="row  contentLabel">
                     <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.age")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.PersonalInformation.Age}}
                    </div>

                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.gender")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.PersonalInformation.Gender}}
                    </div>
                 </div>

                 <div class="row  contentLabel">
                     <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.maritalstatus")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.PersonalInformation.MaritalStatus}}
                    </div>

                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.nationality")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.PersonalInformation.Nationality}}
                    </div>
                </div>

                 
                <div class="row  contentLabel">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.countryofbirth")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.PersonalInformation.CountryOfBirth}}
                    </div>

                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.dependentcount")}}
                        </div>

                        <div class="col-xs-12 col-md-3 q-mb-md" v-if="StoreStateAOD.PersonalInformation.IsDependents===false">                
                           0
                        </div>

                        <div class="col-xs-12 col-md-3 q-mb-md" v-else>                        
                           {{StoreStateAOD.PersonalInformation.NoOfDependents}}                   
                        </div>

                </div>
                 <div class="row  contentLabel">
                     
                        
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.epfno")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                            {{StoreStateAOD.PersonalInformation.EPFNumber}} 
                    </div>	
                    
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.epfaccount")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                            {{StoreStateAOD.PersonalInformation.EPFAccountType}}
                    </div>
                
                 </div>

                 <div class="row  contentLabel q-mb-md">
                    
                    
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.shariahdate")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                            {{StoreStateAOD.PersonalInformation.EPFIEffectiveDate}}
                    </div>
                    
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.holderstatus")}}
                    </div>
                    <div class="col-xs-12 col-md-3">
                            {{StoreStateAOD.PersonalInformation.HolderStatus}}
                    </div>
                 </div>

                <div class="row  contentLabel q-mb-md">
                    
                     <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.household")}}
                    </div>
                    <div class="col-xs-12 col-md-3 ">
                            {{StoreStateAOD.MonthlyHouseholdIncome| thousandSeparator}}
                    </div>
                    
                 <!--   <div class="col-2">
                        Investment Purpose
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.PersonalInformation.InvestmentPurposeNames}}
                    </div>-->
                </div>

                <q-separator style="margin-bottom: 16px; "/>

                <div class="row contentLabel">

                            <div class="col-xs-12 col-md-9 col-lg-6 text-bold q-pr-md">
                               {{$t("Fatca-Detail.statement1")}}
                            </div>
                            
                                    <div class="col-xs-12 col-md-3 col-lg-6 q-mb-md" v-if="StoreStateFATCA.PersonalAsset===false">
                                        {{$t("common.false")}}
                                    </div>
                                <div class= "col-xs-12 col-md-3 col-lg-6 q-mb-md" v-if="StoreStateFATCA.PersonalAsset!==false">
                                    <div class="upper" >
                                        {{StoreStateFATCA.PersonalAssetNames}}
                                    </div>
                                </div>

                            <div class="col-xs-12 col-md-9 col-lg-6 text-bold q-pr-md">
                               {{$t("Fatca-Detail.statement2")}}
                            </div>
                                <div class="col-xs-12 col-md-3 col-lg-6 q-mb-md" v-if="StoreStateFATCA.SophisticatedInvestor===false">
                                    {{$t("common.false")}}
                                </div>

                            <div class="col-xs-12 col-md-3 col-lg-6 q-mb-md" v-if="StoreStateFATCA.SophisticatedInvestor!==false">
                                <div class="upper" >
                                    {{StoreStateFATCA.SophisticatedInvestor}}  
                                </div>
                            
                            </div>
                    </div>

            
                <div class="row  contentLabel">
                   
                    <div class="col-xs-12 col-md-9 col-lg-6 text-bold q-pr-md">
                        {{$t("Fatca-Detail.statement3")}}
                    </div>
                    <div >
                        <div class="upper col-xs-12 col-md-3 col-lg-6 q-mb-md" v-if="StoreStateFATCA.PEP===true">
                            {{StoreStateFATCA.PEP}} 
                        </div>
                        <div class="col-xs-12 col-md-3 col-lg-6 q-mb-md" v-if="StoreStateFATCA.PEP===false">
                            {{$t("common.false")}}
                        </div>
                    </div>
                </div>

                <!-- if PEP true -->

                 <div class="row  contentLabel">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md" v-if="StoreStateFATCA.PEP===true">
                               {{$t("Fatca-Detail.pepposition")}}
                        </div>

                        <div class="col-xs-12 col-md-3 q-mb-md" v-if="StoreStateFATCA.PEP===true">
                            {{StoreStateFATCA.PEPPosition}}

                        </div>
                 
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md" v-if="StoreStateFATCA.PEP===true">
                               {{$t("Fatca-Detail.peprelationship")}}
                        </div>

                        <div class="col-xs-12 col-md-3 q-mb-md" v-if="StoreStateFATCA.PEP===true">
                            {{StoreStateFATCA.PEPRelationship}}

                        </div>
                 </div>
               <!-- <div class="row q-pb-sm">
                    
                     <div class="col-2">
                        Source Of Wealth
                    </div>
                    <div class="col">
                        {{StoreStateAOD.PersonalInformation.SourceOfWealthNames}}
                    </div> 
                </div>-->
            </q-card-section>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryPersonalInformation',
    data() {
        return {
            StoreStateAOD : store.state.AOD,            
            StoreStateFATCA : store.state.FATCA
        }
    },
    computed: {

    },
    methods: {

    },
  filters: {
    thousandSeparator: function(value) {
        if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          /*   var val = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parseFloat(val).toFixed(2) */

        } else {
            return value
            /* var val = value.toString()
            return parseFloat(val).toFixed(2) */
        }
    }
  } 
    /*,filters: {
		    thousandSeparator: function(value) {
		        if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
                    value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                     var result = value;
                     return parseFloat(result).toFixed(2)
		        } else {
                    var result = value.toString();
                    return parseFloat(result).toFixed(2)
                }
     
          } 
    },*/
}
</script>